module.exports = __webpack_public_path__ + "media/Icons/camera-pos/cam_1-a37040d0c791a2c11c2ca3bd26606848.png";